export type HawkRole = 'admin' | 'moderator' | 'subscriber';

export const HOME_PATH_BY_ROLE: Record<HawkRole, string> = {
  admin: '/dashboard',
  moderator: '/editorial',
  subscriber: '/newsletters',
};

/** Exact paths each role may open (RBAC shell; API must enforce server-side). */
export const ALLOWED_PATHS_BY_ROLE: Record<HawkRole, string[]> = {
  admin: ['/dashboard', '/moderators', '/settings', '/ai-manager', '/mail-manager', '/website-scraper'],
  moderator: ['/editorial', '/scraper-pool', '/collected-raw', '/article-analysis', '/dataroom-setting', '/subscribers', '/templates', '/outbox', '/delivery-history', '/linkedin', '/linkedin-scheduled'],
  subscriber: ['/newsletters'],
};

export function isPathAllowedForRole(pathname: string, role: HawkRole): boolean {
  if (pathname === '/') return true;
  if (role === 'moderator' && pathname.startsWith('/subscribers/')) return true;
  if (role === 'moderator' && pathname.startsWith('/article-analysis/')) return true;
  if (role === 'moderator' && pathname.startsWith('/document-preview/')) return true;
  return ALLOWED_PATHS_BY_ROLE[role].includes(pathname);
}

export function resolveRoleFromUser(user: { role?: string } | null | undefined): HawkRole {
  const r = user?.role;
  if (r === 'admin' || r === 'moderator' || r === 'subscriber') return r;
  return 'admin';
}
